import React from "react";
import image1 from "./map-img/2150166724.jpg";
import image2 from "./map-img/2150166725.jpg";
import image3 from "./map-img/2150166726.jpg";
import image4 from "./map-img/2150166727.jpg";
import image5 from "./map-img/2150166728.jpg";
import image6 from "./map-img/2150166729.jpg";
import image7 from "./map-img/2150166730.jpg";
import image8 from "./map-img/2150166731.jpg";
import image9 from "./map-img/2150166732.jpg";
import image10 from "./map-img/2150166733.jpg";

const ProductList = [
  { id: 1, img: image1, title: "Baby Dress-1", price: "₹.350" },
  { id: 2, img: image2, title: "Baby Dress-2", price: "₹.310" },
  { id: 3, img: image3, title: "Baby Dress-3", price: "₹.290" },
  { id: 4, img: image4, title: "Baby Dress-4", price: "₹.350" },
  { id: 5, img: image5, title: "Baby Dress-5", price: "₹.385" },
  { id: 6, img: image6, title: "Baby Dress-6", price: "₹.330" },
  { id: 7, img: image7, title: "Baby Dress-7", price: "₹.355" },
  { id: 8, img: image8, title: "Baby Dress-8", price: "₹.390" },
  { id: 9, img: image9, title: "Baby Dress-9", price: "₹.450" },
  { id: 10, img: image10, title: "Baby Dress-1", price: "₹.255" },
];

export default ProductList;
